import $ from 'jquery'
import { store } from '../redux/store'
import { setActiveLevel, setActiveSlug } from '../redux/mobile-menu-slice'

const transTime = 300 // miliseconds

let stateOpen = false
let activeLevel = 1
let activeSlug = ''

$(() => {
    const jqMenu = $('.partial-mobile-menu')

    /* Events */
    jqMenu.find('ul li a').on('click', function(event) {
        const jqA = $(this);
        const jqLi = jqA.parent()
        const jqUl = jqLi.parent()
        const level = parseInt(jqUl.data('level'))
        const slug = jqLi.data('slug')
        const parentSlug = jqUl.data('parent-slug');
        if (jqLi.hasClass('has-children')) {
            event.preventDefault();
            store.dispatch(setActiveLevel(level + 1))
            store.dispatch(setActiveSlug(slug))
        } else if (jqLi.hasClass('back')) {
            event.preventDefault();
            console.log(parentSlug)
            store.dispatch(setActiveLevel(level - 1))
            store.dispatch(setActiveSlug(parentSlug))
        }
    })

    /* Redux */
    store.subscribe(() => {
        const state = store.getState().mobileMenu;

        /* Open and close menu */
        if (stateOpen != state.open) {
            stateOpen = state.open
            if (stateOpen) {
                jqMenu.addClass('open')
            } else {
                jqMenu.removeClass('open')
                setTimeout(() => {
                    store.dispatch(setActiveLevel(1));
                    store.dispatch(setActiveSlug(''));
                }, transTime)
            }
        }

        /* Navigation through levels */
        if (activeLevel != state.activeLevel ||
            activeSlug != state.activeSlug)
        {
            activeLevel = state.activeLevel
            activeSlug = state.activeSlug
            const parentLevel = activeLevel - 1;
            jqMenu.find('ul').each(function () {
                if (parseInt($(this).data('level')) >= activeLevel) {
                    $(this).removeClass('active').removeClass('parented')
                }
            });
            jqMenu.find(`ul[data-level="${parentLevel}"]`)
                .addClass('parented')
            jqMenu.find(`ul[data-level="${activeLevel}"][data-slug="${activeSlug}"]`)
                .addClass('active')
        }
    })
})
